export class AccountingViewKey {
  static readonly ACCOUNTING_ROOT = 'accounting/view/accounting-root';
  static readonly ACCOUNTING_LIST = 'accounting/view/accounting-list';
  static readonly ACCOUNTING_DETAIL = 'accounting/view/accounting-detail';
  static readonly ACCOUNTING = 'accounting/view/accounting';
}
